import { DRList } from "../../dr/Components/list/DRList";

interface ReactModalFrameProps {
    reactModalFrame: string,
}


const ReactModalFrame = (props: ReactModalFrameProps) => {
        switch (props.reactModalFrame.toLowerCase()) {
            case 'drlist':
                return (<DRList ModalType="inbox"/>)
            case 'mortimp':
                return (<DRList ModalType="mortgage"/>)
            case 'inboxinfile':
                return (<DRList ModalType="infile"/>)
            default:
                return (<></>);
        }
    return (<></>);
}

function GetReactModalFrame(props: ReactModalFrameProps) {
    if (props.reactModalFrame !== '' && props.reactModalFrame !== undefined && props.reactModalFrame !== null) {
        return <ReactModalFrame reactModalFrame={props.reactModalFrame} />
    } else {
        return <></>;
    }
}

export default GetReactModalFrame;